import { useTranslation } from 'react-i18next';
import { ClickMenuItem } from './ClickMenu';
import { Icon } from './Icon';

interface ViewFileMenuItemOptionProps {
  fileName: string;
  downloadURL: string;
}

export function ViewFileMenuItemOption({ downloadURL, fileName }: ViewFileMenuItemOptionProps) {
  const { t: tFile } = useTranslation('file');

  return (
    <a download={fileName} target="_blank" href={downloadURL} rel="noopener noreferrer">
      <ClickMenuItem hideOnClick>
        <span className="text-lg font-medium text-white">{tFile('view-file-label')}</span>
        <Icon icon="show" className="text-palette-600" />
      </ClickMenuItem>
    </a>
  );
}
